import { css } from '@emotion/react';

export const progressStyles = css`
  transition: width 0.3s ease-in-out;
`;
